import { render } from "./nexIcon.vue?vue&type=template&id=67dda693"
import script from "./nexIcon.vue?vue&type=script&lang=js"
export * from "./nexIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/containers/logs/logCollections/components/nexIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67dda693"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67dda693', __exports__)) {
    api.reload('67dda693', __exports__)
  }
  
  module.hot.accept("./nexIcon.vue?vue&type=template&id=67dda693", () => {
    api.rerender('67dda693', render)
  })

}


export default __exports__